module.exports = __webpack_public_path__ + "static/media/channel-created.70fb963c.png";